var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20a1.21 1.21 0 01-.891-.36c-.24-.24-.36-.537-.359-.89V6.25c0-.354.12-.651.36-.891s.537-.36.89-.359c.354 0 .651.12.891.36s.36.537.359.89v12.5c0 .354-.12.651-.36.891s-.537.36-.89.359zM5.937 18.719c-.416.291-.843.312-1.28.062-.438-.25-.657-.625-.657-1.125V7.344c0-.5.219-.87.656-1.11.438-.24.865-.224 1.282.047l7.75 5.188c.374.25.562.594.562 1.031 0 .438-.188.781-.563 1.031l-7.75 5.188z",
    fill: "currentColor"
  })));
}
export default SvgNext;